import { gql } from "@apollo/client";

export const CREATE_SUBSCRIPTION = gql`
	mutation CreateSubscription($subscription: SubscriptionInput!) {
		createSubscription(input: { subscription: $subscription }) {
			clientMutationId
		}
	}
`;

export const GET_WINE_CLUB_SUBSCRIPTIONS = gql`
	query GetSubscriptionList {
		mySubscriptions(filter: { wineClubId: { isNull: false } }) {
			nodes {
				id
				status
				createdAt
				wineClub {
					bottles
					name
					frequency
				}
			}
		}
	}
`;

export const GET_SUBSCRIPTIONS = gql`
	query GetSubscriptionList {
		mySubscriptions {
			nodes {
				id
				status
				frequency
				bottles
				createdAt
				subscriptionProducts {
					nodes {
						variant {
							name
							product {
								id
								imageSrc
								name
							}
						}
					}
				}
			}
		}
	}
`;
